import React from 'react';

import { SimpleTooltip } from '@eluve/components';
import {
  Button,
  Icon,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Stack,
  Text,
} from '@eluve/components';

interface SegmentMetadataPopoverProps {
  metadata: Record<string, unknown> | null;
}

const formatValue = (value: unknown): string => {
  if (value == null) return 'N/A';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};

export const SegmentMetadataPopover: React.FC<SegmentMetadataPopoverProps> = ({
  metadata,
}) => {
  const entries = metadata ? Object.entries(metadata) : [];
  const hasMetadata = entries.length > 0;

  return (
    <Popover>
      <SimpleTooltip label="Segment Metadata">
        <PopoverTrigger asChild>
          <Button variant="outline" disabled={!hasMetadata}>
            <Icon name="Braces" size="auto" />
          </Button>
        </PopoverTrigger>
      </SimpleTooltip>
      <PopoverContent className="w-80" align="start">
        <Stack gap={4}>
          <Text>Segment Metadata</Text>
          {entries.map(([key, value]) => (
            <Stack
              key={key}
              align="center"
              justify="between"
              className="rounded-md border p-2 pl-3"
              gap={2}
              direction="horizontal"
            >
              <div className="min-w-0 flex-1">
                <Text size="xs">{key}</Text>
                <Text className="truncate" color="tertiary" size="xs">
                  <span title={formatValue(value)}>{formatValue(value)}</span>
                </Text>
              </div>
            </Stack>
          ))}
        </Stack>
      </PopoverContent>
    </Popover>
  );
};
